import { isLocationPath, type UserLocation } from './protocol';

export const toUserLocation = (path: string): UserLocation | undefined =>
  isLocationPath(path) ? { path } : undefined;
